Object.defineProperty(exports, '__esModule', { value: true });

var typographyPresets = {
    mobile: {
        list: {
            text: {
                primary: {
                    tag: 'div',
                    view: 'primary-medium',
                },
                secondary: {
                    tag: 'div',
                    color: 'secondary',
                    view: 'primary-small',
                },
            },
        },
    },
};

exports.typographyPresets = typographyPresets;
